module.exports = __webpack_public_path__ + "static/templates/bulk-upload-vi.2FPdgr8.xlsx";